import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash-es';
import classnames from 'classnames';
/* Utils */
import { getStaticImageUrl } from 'client/utils/image-helpers';

export function IconWithText({ info = {}, isCapOneIneligible = false, classNames = '' }) {
  return (
    <div
      className={classnames('d-flex flex-column align-items-center', classNames)}
      style={{ fontSize: '0.875rem', lineHeight: '1.25rem' }}
    >
      <div style={{ marginBottom: '4px', height: '30px' }}>
        <img src={getStaticImageUrl(get(info, 'icon'))} alt="" loading="lazy" width={get(info, 'width')} />
      </div>
      <div className="fw-medium">
        {isCapOneIneligible ? get(info, 'textIneligible1', get(info, 'text1')) : get(info, 'text1')}
      </div>
      <div className="fw-medium">
        {isCapOneIneligible ? get(info, 'textIneligible2', get(info, 'text2')) : get(info, 'text2')}
      </div>
    </div>
  );
}

IconWithText.propTypes = {
  info: PropTypes.shape({}),
  isCapOneIneligible: PropTypes.bool,
  classNames: PropTypes.string,
};
